import Aspect169Icon from 'assets/svgr-icons/Aspect_Ratio_16_9_Dropdown.svg'
import Aspect916Icon from 'assets/svgr-icons/Aspect_Ratio_9_16_Dropdown.svg'
import { T } from 'consts/translationKeys'
import { TCanvasSizeKey } from 'consts'
import { translate } from 'utils/translations'

export const ORIGINAL_RATIO_SENTINEL = 'original'

interface IAspectRatioOption {
  key: TCanvasSizeKey
  label: string
  ratio: string
  icon: typeof Aspect169Icon
}

export const getAspectRatioOptions = (): IAspectRatioOption[] => [
  {
    key: 'widescreen',
    label: translate(T.WIDESCREEN_LABEL),
    ratio: '16:9',
    icon: Aspect169Icon
  },
  {
    key: 'portrait',
    label: translate(T.PORTRAIT_LABEL),
    ratio: '9:16',
    icon: Aspect916Icon
  },
  {
    key: 'vertical',
    label: translate(T.VERTICAL_LABEL),
    ratio: '4:5',
    icon: Aspect916Icon
  },
  {
    key: 'square',
    label: translate(T.SQUARE_LABEL),
    ratio: '1:1',
    icon: Aspect169Icon
  },
  {
    key: 'standard',
    label: translate(T.STANDARD_LABEL),
    ratio: '4:3',
    icon: Aspect169Icon
  },
  {
    key: 'classic',
    label: translate(T.CLASSIC_LABEL),
    ratio: '5:4',
    icon: Aspect169Icon
  },
  {
    key: 'original',
    label: translate(T.ORIGINAL_LABEL),
    ratio: ORIGINAL_RATIO_SENTINEL,
    icon: Aspect169Icon
  }
]
